import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { WidgetBaseComponent } from './widget.base-component';
import * as fromHomepageModuleState from '../../+state/homepage-module/';

import { Observable } from 'rxjs';
import { IActionState } from '../../utils';

@UntilDestroy()
@Directive()
export abstract class HomePageModuleBaseComponent extends WidgetBaseComponent {
  @Input() inWidget = false;
  @Output() moduleTapped = new EventEmitter();
  homepageModule$: Observable<string>;
  homepageModuleActionState$: Observable<IActionState>;
  setVisibility = false;
  homepageModuleToken: string;
  imagePath = '~/assets/shared/images/homepage-module.png';

  protected constructor(
    protected homepageModuleStore: Store<fromHomepageModuleState.IHomepageModelState>
  ) {
    super();
    this.homepageModule$ = this.homepageModuleStore
      .select(fromHomepageModuleState.getHomepageModuleToken)
      .pipe(untilDestroyed(this));
    this.homepageModuleActionState$ = this.homepageModuleStore
      .select(fromHomepageModuleState.getHomepageModuleActionState)
      .pipe(untilDestroyed(this));
  }
}
